import React from 'react';
import Paper from "@mui/material/Paper";
import { Card, CardMedia, TextField, Typography } from '@mui/material';
import ProductImageView from './ProductImageView';
import no_images from '../images/no_images@2x.png';

const ProductCard = ({product, nocard=false}) => {
    let img_field = []
    if (product.front_template !== null) {
        img_field.push(<ProductImageView key={0} product={product} side={"front"} width={220} height={128} nolabel={true} nocard={true} />)
    } else {
        img_field.push(<CardMedia key={0} image={no_images} sx={{width: 220, height: 128, borderRadius:1}} />)
    }
    if (nocard) {
        return <div key={product.id} >
            <center>{img_field}</center>
            <center><Typography variant="subtitle1">{product.name}</Typography></center>
        </div>
    }
    return <Paper elevation={1}><Card key={product.id} sx={{width: 256, minHeight: 180, paddingTop: 2}}>
            <center>{img_field}</center>
            <center><Typography variant="subtitle1">{product.name}</Typography></center>
    </Card></Paper>
}

const ProductAddNewCard = ({onAddProduct = null}) => {
    const addNewProduct = (name) => {
        if(onAddProduct) {
            onAddProduct(name);
        }
    }

    return (
        <Paper elevation={1}><Card key="add_new" sx={{width: 256, minHeight: 180, paddingTop: 2}}>
            <center><Typography variant="subtitle1">Add new</Typography></center>
            <center><TextField
                sx={{marginTop: 2}}
                placeholder='Type and press enter...'
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        addNewProduct(e.target.value);
                    }
                }}
            /></center>
        </Card></Paper>);
}

export default ProductCard;
export { ProductCard, ProductAddNewCard };